(function () {
  const SELECTORS = {
    toggle: '[data-collection-footer-links-toggle]',
    externalToggle: '[data-collection-footer-links-external-toggle]',
    panel: '[data-collection-footer-links-panel]',
  };

  class CollectionFooterLinks extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.toggleButton = this.querySelector(SELECTORS.toggle);
      this.panel = this.querySelector(SELECTORS.panel);

      if (!this.toggleButton || !this.panel) return;

      this.panelLinks = Array.from(this.panel.querySelectorAll('a'));
      this.externalToggleButtons = Array.from(document.querySelectorAll(SELECTORS.externalToggle)).filter((button) => {
        const target = button.dataset.collectionFooterLinksTarget;

        return !target || target === this.id || target === this.panel.id;
      });
      this.initialized = true;
      this.toggleButton.addEventListener('click', () => this.setOpen(!this.classList.contains('is-open')));
      this.externalToggleButtons.forEach((button) => {
        button.setAttribute('aria-controls', this.panel.id);
        button.addEventListener('click', () => {
          const shouldScroll = !this.classList.contains('is-open');

          this.setOpen(shouldScroll);

          if (shouldScroll) {
            this.scrollPanelIntoView();
          }
        });
      });
      window.addEventListener('resize', () => this.syncPanelHeight());

      this.setOpen(this.dataset.defaultOpen === 'true', false);
    }

    setOpen(isOpen, animate = true) {
      this.classList.toggle('is-open', isOpen);
      this.toggleButton.setAttribute('aria-expanded', isOpen.toString());
      this.externalToggleButtons.forEach((button) => {
        button.classList.toggle('is-open', isOpen);
        button.setAttribute('aria-expanded', isOpen.toString());
      });
      this.panel.setAttribute('aria-hidden', (!isOpen).toString());
      this.panelLinks.forEach((link) => {
        if (isOpen) {
          link.removeAttribute('tabindex');
        } else {
          link.setAttribute('tabindex', '-1');
        }
      });

      if (!animate) {
        this.panel.style.transition = 'none';
      }

      this.panel.style.maxHeight = isOpen ? `${this.panel.scrollHeight}px` : '0px';

      if (!animate) {
        window.requestAnimationFrame(() => {
          this.panel.style.transition = '';
        });
      }
    }

    syncPanelHeight() {
      if (!this.classList.contains('is-open')) return;
      this.panel.style.maxHeight = `${this.panel.scrollHeight}px`;
    }

    scrollPanelIntoView() {
      window.requestAnimationFrame(() => {
        const panelTop = this.panel.getBoundingClientRect().top;
        const targetTop = window.innerHeight * 0.45;
        const scrollDistance = Math.max(panelTop - targetTop, 0);

        if (scrollDistance === 0) return;

        window.scrollBy({
          top: scrollDistance,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      });
    }
  }

  if (!customElements.get('collection-footer-links')) {
    customElements.define('collection-footer-links', CollectionFooterLinks);
  }
})();
